import { Label } from '@headlessui/react'
import React, { useState, useEffect } from 'react'
import { useTheme } from '../../ThemeContext'; // Adjust the path as necessary

const IssueCategoris = ({ category, handleChange }) => {
    const { theme } = useTheme(); // Get the theme from context

    const catTypes = [
        { value: "", Label: "Select Category" },
        { value: "Bug", Label: "Bug" },
        { value: "Feature", Label: "Feature" },
        { value: "Task", Label: "Task" },
        { value: "Epic", Label: "Epic" },

    ]
    return (
        <div>
            <label className="block text-sm font-medium mb-2">Category</label>
            <select
                className={` w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}

                onChange={handleChange} value={category}>
                {catTypes.map((cat, index) => (
                    <option key={index} value={cat.value}>{cat.Label}</option>

                ))}
            </select>
        </div>
    )
}

export default IssueCategoris